import React from 'react'
import Button, { ButtonProps } from '@material-ui/core/Button'

export let ButtonView: React.FC<ButtonProps> = ({ ...other }) => {
    return <Button {...other} variant="contained" />
}

let MyButton: React.FC<ButtonProps> = ({ ...others }) => {
    const styleCustom = { minWidth: '125px', ...others?.style }
    return <ButtonView {...others} style={styleCustom} />
}

export default MyButton
